const PLAN_NAMES = {
  SOLAR_BOOST: 'Origin Solar Boost',
  ORIGIN_ESSENTIALS: 'ORIGIN ESSENTIALS',
  ORIGIN_MAXIMISER: 'Origin Maximiser',
  ORIGIN_SAVER: 'Origin Saver',
  BILL_SAVER: 'Bill Saver',
  ORIGIN_MAX_SAVER: 'Origin Max Saver',
  ORIGIN_BASIC: 'Origin Basic',
  ORIGIN_FLEXI: 'Origin Flexi',
  ORIGIN_SUPPLY: 'Origin Supply',
  ORIGIN_BASIC: 'Origin Basic',
  HOME_SUPPORT: 'Origin Home Support',
  EVERYDAY_REWARDS: 'Origin Everyday Rewards',
  ORIGIN_GO: 'Origin Go'
};

export default PLAN_NAMES;
